module.exports = __webpack_public_path__ + "images/prey_rgba(0,0,0,0.7).7552324cad41190076252a2d9d8170cc.jpg";